import { keyGenerator } from "../util/keyGeneration";
import { updateVDomElement, VNode } from "../util/virtualDom";
import TestimonialCommon, { TESTIMONIAL_SELECTOR } from "./testimonial-common";

export class TestimonialHelperIdb {
    private static instance: TestimonialHelperIdb | null = null;

    private conceptId: any = null;
    private countryId: any = null;
    private weblocationId: string = "";
    private readonly pageSize: number;
    private readonly selector: string = TESTIMONIAL_SELECTOR;
    
    private readonly realUl: HTMLElement | null = null;
    private readonly selectedStarRating: number;
    private readonly ratingCache: { [key: number]: any } = {}; // Cache for storing rating data
    

    static getInstance(): TestimonialHelperIdb {
        TestimonialHelperIdb.instance??= new TestimonialHelperIdb();
        return TestimonialHelperIdb.instance;
    }

    constructor() {
        this.pageSize = window.innerWidth >= 768 ? 30 : 4; // Number of items per page
        this.selectedStarRating = 5;
    }

    domLookup(){
        this.conceptId = (document.getElementById("conceptId") as HTMLInputElement)?.value ?? '';
        this.weblocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem("franchiseWebLocationId") ?? '';
        if (sessionStorage.getItem('countryCode') != null) {
            const storedCode = sessionStorage.getItem('countryCode')?.toLowerCase();
            if (storedCode === "us") {
                this.countryId = "1";
            } else {
                this.countryId = "2";
            }
        } else {
            const countryCode =  (document.getElementById("countryCode") as HTMLInputElement)?.value;
            if (countryCode) {
                if (countryCode?.toLowerCase() === "us") {
                    this.countryId = "1";
                } else {
                    this.countryId = "2";
                }
            } else {
                this.countryId = "1";
            }
        }
    }

    async getData(){
            const url = TestimonialCommon.getInstance().buildUrl(
                this.conceptId,
                this.weblocationId || 0,
                this.countryId,
                1,
                this.pageSize,
                this.selectedStarRating
            );
            const cacheKey = keyGenerator(url, this.selector);
            let  cachedData = await this.getFromCache(cacheKey);
            const wasCacheHit = Array.isArray(cachedData) && cachedData.length > 0;
            if(wasCacheHit){
                return;
            }
            cachedData = await this.getDataFromServer(this.selectedStarRating);
            let storedOverallRating;
            let storedGrandTotal;
            if(cachedData[0]?.overallRating && cachedData[0]?.grandTotal){
                storedOverallRating = cachedData[0]?.overallRating;
                storedGrandTotal = cachedData[0]?.grandTotal;
                const obj = {
                    "or" : storedOverallRating,
                    "gt" : storedGrandTotal
                }
                sessionStorage.setItem(`rev-${this.weblocationId || 'national'}`, JSON.stringify(obj));
            }
            const lists = await this.createTestimonialLists(cachedData);
            const testimonialListNode: VNode = {
                type: 'ul',
                props: {},
                children: lists,
            };
            if (this.realUl) {
                updateVDomElement(this.realUl, testimonialListNode);
            }
            await this.storeInCache(cacheKey, cachedData);
    }


    private async storeInCache(key: string, data: any): Promise<void> {
        return TestimonialCommon.getInstance().storeInCache(key, data);
    }

    public createTestimonialVNode(data: any): VNode | null {
        return TestimonialCommon.getInstance().createTestimonialVNode(data);
    }

    public generateRatingStars(rating: number): string {
        return TestimonialCommon.getInstance().generateRatingStars(rating);
    }

    protected getDataFromServer(rating: number) {
        return TestimonialCommon.getInstance().getDataFromServer(
            this.conceptId,
            this.weblocationId || 0,
            this.countryId,
            1,
            this.pageSize,
            rating
        );
    }

    private async getFromCache(key: string): Promise<any> {
        return TestimonialCommon.getInstance().getFromCache(
            key,
            this.selectedStarRating,
            this.ratingCache
        );
    }
    private async handleCacheFailure() {
        return TestimonialCommon.getInstance().handleCacheFailure(this.ratingCache);
    }

    private async createTestimonialLists(result: any[]): Promise<VNode[]> {
        return TestimonialCommon.getInstance().createTestimonialLists(result);
    }
}
